class Statistics {
    // eslint-disable-next-line class-methods-use-this
    calcSOV(data, { sumAlsoTierInstances = false } = {}) {
        const dataWithSOV = { ...data };
        const calcSum = (sum, b) => sum + parseFloat(b.revenue || 0);
        const bidders = dataWithSOV.bidders || [];
        const tiers = dataWithSOV.tiers || [];

        const totalRevenueBidders = bidders.reduce(calcSum, 0);

        const totalRevnueNonBidders = tiers
            .reduce((sumTier, tier) => sumTier + (tier.instances ? tier.instances.reduce(calcSum, 0) : 0), 0);
        let totalRevenue = totalRevenueBidders + totalRevnueNonBidders;

        if (totalRevenue > 0) {
            dataWithSOV.bidders = bidders.map((bidder) => {
                const bidderClone = { ...bidder }; // decouple instance
                bidderClone.sov = parseFloat(((parseFloat(bidder.revenue || 0) / totalRevenue) * 100).toFixed(2));
                dataWithSOV.maxSov = Math.max(dataWithSOV.maxSov || 0, bidderClone.sov);
                return bidderClone;
            });

            if (sumAlsoTierInstances) {
                if (data.backfill) {
                    totalRevenue += data.backfill.revenue || 0;
                    dataWithSOV.backfill.sov = parseFloat(
                        ((parseFloat(data.backfill.revenue || 0) / totalRevenue) * 100).toFixed(2)
                    );
                    dataWithSOV.maxSov = Math.max(dataWithSOV.maxSov || 0, dataWithSOV.backfill.sov);
                }
                dataWithSOV.tiers = tiers.map((tier) => {
                    const tierClone = { ...tier };
                    if (tier.instances) {
                        tierClone.instances = tierClone.instances.map((instance) => {
                            const instanceClone = { ...instance };
                            instanceClone.sov = parseFloat(
                                ((parseFloat(instance.revenue || 0) / totalRevenue) * 100)
                                    .toFixed(2)
                            );
                            dataWithSOV.maxSov = Math.max(dataWithSOV.maxSov || 0, instanceClone.sov);
                            return instanceClone;
                        });
                    }
                    return tierClone;
                });
            }
        }

        return dataWithSOV;
    }
}

export default new Statistics();
